import React from 'react';
const modalSlack = () => import(/* webpackChunkName: "integration-slack" */ 'core/gd-modals/integrations/slack/modal-slack.jsx');

class IntegrationModalsManager {

    constructor() {}

    googleDrive(params) {
        gd.modal.showGeneric({
            className: 'modal-google-drive',
            component: require('./integrations/google-drive/modal-google-drive-view'),
            params: {
                this: this,
                attachments: params.attachments,
                organizationId: params.organizationId,
                type: params.type,
                onAttachFiles: params.onAttachFiles,
                onChangeRoot: params.onChangeRoot
            }
        });
    }

    slackViewChannel(slackChannel, slackChannels, callback) {

        gd.modal.loadAndShow(modalSlack, false, {
            className: 'modal-slack',
            modalType: 'v4',
            toggleCallback: (isOpen) => {
                // console.log("toggle")
            },
            params: {
                slackChannels   : slackChannels,
                callback        : callback,
                slackChannel    : slackChannel
            }
        });

    }

    slackAddChannel(slackChannels, callback) {

        gd.modal.loadAndShow(modalSlack, false, {
            className: 'modal-slack',
            modalType: 'v4',
            toggleCallback: (isOpen) => {
                // console.log("toggle")
            },
            params: {
                slackChannels   : slackChannels,
                callback        : callback
            }
        });

    }


    gitHubSelectBranch(companyId, callback) {
        gd.modal.showV4({
            className: 'modal-git',
            component: require('./integrations/git/modal-git-main.jsx'),

            params: {
                companyId: companyId,
                mode: 'select-branch',
                callback: callback,
                gitProvider: 'github'
            }
        });
    }

    gitLabSelectBranch(companyId, callback) {
        gd.modal.showV4({
            className: 'modal-git',
            component: require('./integrations/git/modal-git-main.jsx'),

            params: {
                companyId: companyId,
                mode: 'select-branch',
                callback: callback,
                gitProvider: 'gitlab'
            }
        });
    }

    gitHubSelectCommit(companyId, callback) {
        gd.modal.showV4({
            className: 'modal-git',
            component: require('./integrations/git/modal-git-main.jsx'),
            params: {
                companyId: companyId,
                mode: 'select-commit',
                gitProvider: 'github',
                callback: callback
            }
        });
    }

    gitLabSelectCommit(companyId, callback) {
        gd.modal.showV4({
            className: 'modal-git',
            component: require('./integrations/git/modal-git-main.jsx'),
            params: {
                companyId: companyId,
                mode: 'select-commit',
                gitProvider: 'gitlab',
                callback: callback
            }
        });
    }

}

module.exports = IntegrationModalsManager;